import { Link, type To } from 'react-router-dom';

import { Stack, StackProps } from '@mui/material';

import RaskLogo from '@/shared/assets/images/rask.svg';

import { SLinkContainer, SWhiteLabelIcon, SWhiteLabelLogo } from './styled';

type LogoProps = {
  isCompact?: boolean;
  isWhiteLabel?: boolean;
  target?: string;
  to?: To;
} & StackProps;

export const Logo = ({ children, isCompact = false, isWhiteLabel = false, target, to = '', ...props }: LogoProps) => {
  if (isWhiteLabel) {
    return (
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        padding="10px 10px 10px 14px"
        {...props}
      >
        <SLinkContainer
          sx={{
            marginRight: isCompact ? 16 : 0,
            width: isCompact ? 32 : '100%',
          }}
        >
          <Link data-testid="sidebar-logo-rask" to="/">
            <Stack alignItems="center" direction="row" gap={8}>
              <SWhiteLabelIcon />
              <Stack>
                <SWhiteLabelLogo variant="body-2-md">Video</SWhiteLabelLogo>
                <SWhiteLabelLogo variant="body-2-md">Translation Tool</SWhiteLabelLogo>
              </Stack>
            </Stack>
          </Link>
        </SLinkContainer>
        {children}
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between" padding="10px 10px 10px 18px">
      <SLinkContainer
        sx={{
          marginRight: isCompact ? 16 : 0,
          width: isCompact ? 24 : '100%',
        }}
      >
        <Link data-testid="sidebar-logo-rask" target={target} to={to}>
          <img alt="Rask" height="24" src={RaskLogo} width="128" />
        </Link>
      </SLinkContainer>
      {children}
    </Stack>
  );
};
